

const Footer = () => {
  return(
    <>
    <footer>
        <p>&copy; Geegstack Academy, 2023</p>
    </footer>
    </>
  )
}
export default Footer;